import { useEffect, useState } from "react";

import { Combobox } from "@newsela/angelou";
import PropTypes from "prop-types";

import useChallengeReportStudentsGet from "@/challenges/utils/useChallengeReportStudentsGet";
import useChallengeReportGet from "@/challenges/utils/useChallengeReportGet";
import useClassroomsGet from "../utils/useClassroomsGet/useClassroomsGet";
import {
  container,
  dropDownWrapper,
  comboBoxCss,
} from "./ChallengesTeacher.style";

import ChallengesTeacherBanner from "./ChallengesTeacherBanner";
import ChallengesTeacherReport from "./ChallengesTeacherReport";
import ChallengesTeacherStudentData from "./ChallengesTeacherStudentData";
import ChallengesTeacherTabsContainer from "./ChallengesTeacherTabsContainer";
import ChallengesTeacherTopicsList from "./ChallengesTeacherTopicsList";

const propTypes = {
  expirationDate: PropTypes.any,
  activeTab: PropTypes.any,
  subjects: PropTypes.any,
  setActiveTab: PropTypes.any,
  activeData: PropTypes.any,
};

const ChallengesTeacher = ({
  expirationDate,
  activeTab,
  subjects,
  setActiveTab,
  activeData,
}) => {
  const [topics, setTopics] = useState([]);
  const [reportData, setReportData] = useState(null);
  const [getReportData] = useChallengeReportGet();
  const [getClassRoom] = useClassroomsGet();
  const [studentReportData, setStudentReportData] = useState(null);
  const [getStudentReportData] = useChallengeReportStudentsGet();
  const [classRoomsData, setClassRoomsData] = useState([]);
  const [filteredClassroom, setfilteredClassroom] = useState([]);
  const [selectedClassroom, setSelectedClassRoom] = useState(null);
  const [challengeId, setChallengeId] = useState(activeData?.challenge_id);

  const updateReport = async () => {
    setReportData(null);
    const { data } = await getReportData({
      challengeId,
      classroomId: filteredClassroom,
    });
    setReportData(data?.success ? data?.data : "no data");
  };

  const fetchClassroomData = async () => {
    const { data } = await getClassRoom({ challengeId });
    setClassRoomsData(data?.data?.classrooms);
  };

  const updateStudentReport = async () => {
    setStudentReportData(null);

    const { data } = await getStudentReportData({
      challengeId,
      classroomId: filteredClassroom,
    });

    setStudentReportData(data?.success ? data?.data : "no data");
  };

  useEffect(() => {
    if (activeData?.topics) {
      setTopics(activeData.topics);
      if (activeData.challenge_id) setChallengeId(activeData.challenge_id);
    }
  }, [activeData]);

  useEffect(() => {
    if (challengeId) {
      updateReport();
      updateStudentReport();
      fetchClassroomData();
    }
  }, [challengeId]);

  useEffect(() => {
    if (challengeId) {
      updateReport();
      updateStudentReport();
    }
  }, [filteredClassroom]);

  useEffect(() => {
    const defaultValue = classRoomsData.find(
      (classroom) => classroom?.name === "All classes",
    );
    if (defaultValue === undefined) {
      classRoomsData.unshift({
        id: null,
        name: "All classes",
        is_banned: false,
      });
    }
    setSelectedClassRoom(classRoomsData[0]);
  }, [classRoomsData]);

  useEffect(() => {
    setfilteredClassroom(selectedClassroom?.classroom_id);
  }, [selectedClassroom]);

  return (
    <div css={container}>
      <ChallengesTeacherBanner expirationDate={expirationDate} />
      <ChallengesTeacherTabsContainer
        activeTab={activeTab}
        options={subjects}
        setActiveTab={setActiveTab}
        activeData={activeData}
      />
      <ChallengesTeacherTopicsList topics={topics} />
      <div css={dropDownWrapper}>
        <Combobox
          label="Challenge insights"
          items={classRoomsData}
          __cssFor={{
            root: comboBoxCss,
          }}
          itemToString={(item) => {
            return item ? item.name : "";
          }}
          selectedItem={selectedClassroom}
          onSelectedItemChange={(e) => setSelectedClassRoom(e.selectedItem)}
        />
      </div>
      <ChallengesTeacherReport data={reportData} />
      <ChallengesTeacherStudentData data={studentReportData} />
    </div>
  );
};

ChallengesTeacher.propTypes = propTypes;

export default ChallengesTeacher;
